<template>
  <div class="salesLadingbillAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('salePurchase.add.info') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-info
            :disabled="disabled"
            :basicData="basicData"
            :userInfo="userInfo"
            :returnStatusName="returnStatusName"
            :contractDetailCategory="$route.query.contractDetailCategory"
            ref="basicForm"
            v-if="loadFlag"
            @changeStorageNo="changeStorageNo"
            @changeCustomerNo="changeCustomerNo"
            @changeCurrencyList="changeCurrencyList"
            @deliveryMethodChange="deliveryMethodChange"
          />
        </div>
      </el-collapse-item>
      <!-- 商品信息 -->
      <div class="m-b">
        <el-tabs type="card" v-model="activeNameTab" class="common-tab">
          <el-tab-pane label="商品明细" name="first">
            <product-details
              v-if="loadFlag"
              :isEdit="!disabled"
              ref="productDetails"
              :basicData="basicData"
              :storageLadingPickings="storageLadingPicking"
              @goodsTableChange="goodsTableChange"
              @calcLadingPicking="calcLadingPicking"
              @ladingQuantityChange="ladingQuantityChange"
              @calcQuantityChange="changePrice"
              @refreshData="refreshData"
              @getDeleveryFlag="getDeleveryFlag"
            />
          </el-tab-pane>
          <!-- 批次拣配结果 -->
          <el-tab-pane :label="$t('salesBill.tab.pickingTab')" name="seconed">
            <batch-matching-results
              v-if="loadFlag"
              :isEdit="!disabled"
              ref="pickingTab"
              :basicData="basicData"
              :storageLadingPickings="storageLadingPicking"
              :storageLadingPickingDetail="storageLadingPickingDetail"
              :deleveryFlag="this.deleveryFlag"
              @calcLadingPicking="calcLadingPicking"
              @refreshData="refreshData"
              :deliveryMethod="basicData.deliveryMethod"
              :editConfigFlag="editConfigFlag"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-collapse-item name="2">
        <!--上传附件-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ $t('salesBill.title.uploadFile') }}
          </div>
        </template>
        <div class="collapse-content">
          <!-- <div v-if="show">
            <upload
              v-if="loadFlag"
              v-bind:isShow="!disabled"
              @upload="handleUpload"
              :tableData="storageAttachmentList"
              :isEdit="this.basicData.ladingStatus== 'TDZT03'?false:true"
            />
          </div> -->
          <div>
            <uploads
              v-if="loadFlag"
              v-bind:isShow="true"
              @upload="handleUpload"
              @viewContractFile="viewContractFile"
              :tableData="storageAttachmentList"
              :isEdit="true"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮：根据订单状态展示按钮 -->
    <div class="fixed-bottom-btnList">
      <el-button
        class="saveBtn"
        v-hasPermi="['2021042915235555692']"
        type="primary"
        @click="saveData"
        v-show="
          this.basicData.ladingStatus == 'TDZT01' ||
          this.basicData.ladingStatus == 'TDZT04' ||
          this.basicData.ladingStatus == 'TDZT10' ||
          !this.basicData.ladingStatus
        "
        >{{ $t('salesBill.button.save') }}</el-button
      >
      <!-- <el-button
        class="saveBtn"
        v-hasPermi="['2021042915235555692']"
        type="primary"
        @click="saveactualSendQuantity"
        v-if="
          this.basicData.ladingStatus == 'TDZT07' &&
          (basicData.deliveryMethod == 'JHFS05' ||
            basicData.deliveryMethod == 'JHFS04' ||
            basicData.deliveryMethod == 'JHFS06')
        "
        >{{ '确认实发数' }}</el-button
      > -->
      <!--提单在已审核通过状态，可以修改变动价格-->
      <!-- <el-button
        class="saveBtn"
        type="primary"
        v-hasPermi="['2021102816424983400']"
        @click="editChangePrice"
        v-if="this.basicData.ladingStatus == 'TDZT03' || this.basicData.ladingStatus == 'TDZT07'"
        :disabled="this.basicData.ladingStatus == 'TDZT03'"
        >{{ '修改价格' }}</el-button
      > -->
      <!--提单新增在冻结状态驳回功能，已冻结提单，财务可以驳回-->
      <!-- <el-button
        class="saveBtn"
        v-hasPermi="['2021102816443799378']"
        type="primary"
        @click="Rejected"
        v-if="this.basicData.ladingStatus == 'TDZT05'"
        >{{ '驳回' }}</el-button
      > -->
      <el-button
        class="saveBtn"
        v-hasPermi="['2021042915322753060']"
        type="primary"
        @click="submit"
        v-if="
          this.basicData.ladingStatus == 'TDZT01' ||
          this.basicData.ladingStatus == 'TDZT04' ||
          this.basicData.ladingStatus == 'TDZT05' ||
          this.basicData.ladingStatus == 'TDZT10' ||
          !this.basicData.ladingStatus
        "
        >{{ $t('salesBill.button.submit') }}</el-button
      >
      <!-- <el-button
        v-if="transportButton"
        class="saveBtn"
        type="primary"
        @click="surecreatTransportBill"
        v-hasPermi="['2021042915322753060']"
        >{{ $t('salesBill.button.creatTransportBill') }}</el-button
      > -->
      <el-button
        class="saveBtn"
        v-if="this.basicData.ladingStatus == 'TDZT01'"
        type="primary"
        v-hasPermi="['2021042915315175598']"
        @click="deteleBill"
        >{{ $t('salesBill.button.deteleBill') }}</el-button
      >
      <!-- 打印 -->
      <!-- <el-button
        type="primary"
        @click="print"
        v-hasPermi="['2021042915325608569']"
        v-if="this.basicData.ladingStatus == 'TDZT03' || this.basicData.ladingStatus == 'TDZT07'"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.print') }}</el-button
      > -->
      <!-- 撤回 -->
      <el-button
        type="primary"
        @click="withdraw"
        v-if="this.basicData.ladingStatus == 'TDZT07'"
        class="fixed-bottom-btn"
        >{{ this.$t('addSupplierDelivery.detail.withdraw') }}</el-button
      >
      <el-button
        type="primary"
        @click="printHandler"
        v-if="this.basicData.ladingStatus == 'TDZT07'"
        class="fixed-bottom-btn"
        >打印</el-button
      >
      <!-- <el-button class="saveBtn" type="primary" @click="saveData">关闭</el-button> -->
      <!-- <el-button
        v-if="this.basicData.ladingStatus == 'TDZT07'"
        v-hasPermi="['2021042915312103534']"
        type="primary"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.confirm') }}
      </el-button>
      <el-button
        v-hasPermi="['2021042915341643731']"
        v-if="
          this.basicData.ladingStatus == 'TDZT03' &&
          ['notgenerate', 'generated', 'postError'].indexOf(this.basicData.accountingStatus) != -1
        "
        type="primary"
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.accountEntry') }}
      </el-button>
      <el-button
        v-hasPermi="['2021042915343953781']"
        v-if="
          this.basicData.ladingStatus == 'TDZT03' &&
          ['generated', 'postError'].indexOf(this.basicData.accountingStatus) != -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.doSyncVoucher') }}
      </el-button> -->
      <!-- 冲销 -->
      <!-- <el-button
        v-hasPermi="['2021042915350314804']"
        v-if="this.basicData.ladingStatus == 'TDZT03'"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.writeOff') }}
      </el-button> -->
    </div>
    <print-dialog
      ref="printDialog"
      :deliveryNo="$route.query.ladingNo"
      :deleveryFlag="this.deleveryFlag"
    ></print-dialog>
    <change-price
      ref="changePrice"
      :ladingNo="$route.query.ladingNo"
      :ladingId="id"
      @returnPath="returnPath"
    ></change-price>
    <!-- 打印弹框 -->
    <PrintDialog ref="printDialogRef" :apiUrl="printApi" />
    <SelectContractFileDialog
      ref="selectContractFileDialogRef"
      @confirm="confirm"
    ></SelectContractFileDialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import baseInfo from './components/baseInfo';
  import productDetails from './components/productDetails';
  import changePrice from './components/changePrice';
  import batchMatchingResults from './components/batchMatchingResults';
  import { dateFormat } from '@/filters/index';
  import { digitUppercase, toUpperCase } from '@/common/js/util';
  // import upload from '@/components/upload';
  import uploads from './components/upload';
  import creatTransportBill from './js/creatTransportBill';
  import printDialog from './components/printDialog';
  // import { BigNumber } from "bignumber.js";
  import XEUtils from 'xe-utils';
  import Big from 'big.js';
  import SelectContractFileDialog from '@/components/business/SelectContractFileDialog/index.vue';
  import { MessageBox } from 'element-ui';
  export default {
    name: 'materialSalesLadingbillAdd',
    components: {
      baseInfo,
      productDetails,
      changePrice,
      batchMatchingResults,
      // upload,
      uploads,
      printDialog,
      SelectContractFileDialog,
    },
    data() {
      return {
        attachmentCategoryDataList: [], //打印销售提单历史
        voucherFlag: 'AE_SO_MTL_RELEASE', //凭证标识
        printApi: API.PRINT_API,
        load: false,
        supplierName: '',
        supplierNo: '',
        show: true,
        activeNames: ['1', '2', '3'],
        activeNameTab: 'first',
        basicData: {
          ladingNo: '',
          mark: '', //备注
          ladingType: '1', //类型:1:销售提单,2:退换货提单
          ladingStatus: '',
          contractNo: '',
          ladingCurrency: '',
          ladingCurrencyName: '',
          exchangeRate: '',
          tradeTypeName: '',
          tradeType: '',
          ladingBusinessDepartmentNo: '',
          ladingBusinessDepartmentName: '',
          ladingSalesmanNo: '',
          ladingSalesmanName: '',
          customerNo: '',
          customerName: '',
          storageNo: '',
          storageName: '',
          externalContractNo: '',
          deliveryDate: dateFormat(new Date()),
          deliveryMethod: '',
          shippingMethod: '',
          receivingUnit: '',
          ladingTotalQuantity: '',
          ladingTotalQuantityDesc: '',
          businessLadingTotalAmount: '',
          businessLadingTotalAmountOther: '',
          ladingTotalAmountDesc: '',
          deliveryAddress: '',
          isCreditsale: '',
          lastestReceiveMoneyDay: '',
          outstandingAmount: '',
          amountDelivered: '',
          projectInitiationNo: '',
          projectInitiationName: '',
          baseName: '',
          platformCompanyName: '',
          relationLadingFlag: '0',
          relationLadingNo: '',
          relationLadingBusinessCompanyCode: '',
          relationLadingBusinessCompanyName: '',
          relationLadingSalesContractNo: '',
          relationLadingCustomerNo: '',
          relationLadingCustomerName: '',
          relationLadingReceivingUnit: '',
        }, //基本表单信息
        storageLadingPicking: [], //商品明细
        storageLadingPickingDetail: [], //商品明细拣配结果
        storageAttachmentList: [], //附件列表
        loadFlag: false, //详情是否加载完成
        disabled: true, // 页面是否可编辑 true：不可编辑
        returnStatusName: '', //销售退换货标记
        returnStatus: '',
        returnNo: '', //销售退换货单号
        storage: {}, //仓库
        id: '',
        version: '',
        editConfigFlag: false,
        //校验关联结算批次
        checkSettleParams: {
          associationType: '4',
          associationNoList: [],
        },
        deleveryFlag: false,
        ladingStatus: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      transportButton() {
        const { ladingStatus } = this.basicData;
        // 可生成运输单状态：已保存、审批中、审批完成
        return ['TDZT01', 'TDZT02', 'TDZT07'].includes(ladingStatus);
      },
    },
    created() {
      if (this.$route.query.ladingNo) {
        //详情
        this.getLadingDetail(this.$route.query.ladingNo);
      } else {
        // 新增时只带合同号过来：避免浏览器参数很长
        if (this.$route.query.contractNo) {
          this.disabled = false;
          let contractDetailNoList = [];
          if (this.$route.query.contractDetailNoList) {
            contractDetailNoList = this.$route.query.contractDetailNoList.split(',');
          }
          this.getContractDetail(this.$route.query.contractNo, contractDetailNoList);
        } else if (this.$route.query.changeDetail) {
          //从销售换货跳转过来
          this.disabled = false;
          this.getChangeDetail(JSON.parse(this.$route.query.changeDetail));
        }
        this.$nextTick(() => {
          MessageBox.alert(
            '根据业务规则，上游做预结算时，下游不允许出库，必须完成上游终结算后，下游才能出库',
            '提示'
          );
        });
      }
    },
    methods: {
      confirm(file) {
        if (file && file.length) {
          let attachmentIdList = this.storageAttachmentList.map((item) => item.attachmentId);
          file.forEach((item) => {
            if (!attachmentIdList.includes(item.attachmentId)) {
              this.storageAttachmentList.push(item);
            }
          });
        }
      },
      viewContractFile() {
        let data = this.basicData.contractNo ? [this.basicData.contractNo] : [];
        this.$refs.selectContractFileDialogRef?.openDialog('SALES_CONTRACT', data);
      },
      printHandler() {
        this.$refs.printDialogRef.openDialog({
          downloadOrPrint: 'print',
          ladingNo: this.$route.query.ladingNo,
        });
      },
      //交货方式是否为直拨
      getDeleveryFlag(result) {
        this.deleveryFlag = result;
      },
      // 确认
      doConfirmInfo(info) {
        const productData = this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList;
        let isEmpty = false;
        productData.map((it) => {
          console.log(XEUtils.isNull(it.actualSendQuantity));
          if (XEUtils.isNull(it.actualSendQuantity) || it.actualSendQuantity == 0) isEmpty = true;
        });
        if (isEmpty) {
          this.$message({ showClose: true, message: '拣配结果实发数量不能为零', type: 'error' });
          return;
        }
        let params = { id: this.entityDataId, ladingNo: this.basicData.ladingNo, ...info };
        this.conFirmImport(params);
      },
      conFirmImport(params) {
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          if (res.data.code === 10) {
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                params.cancelValidate = true;
                this.conFirmImport(params);
              },
            });
          } else if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getLadingDetail(this.basicData.ladingNo);
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            this.getLadingDetail(this.basicData.ladingNo);
          }
        });
      },
      //撤回
      withdraw() {
        let params = {
          ladingNo: this.$route.query.ladingNo,
          version: this.basicData.version,
          //检查关联结算批次所需参数
          ...this.checkSettleParams,
        };
        this.$confirm('确认更改？', '是否确认撤回？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$axios
            .post(API.RECALL_STORAGELADE, { ...params, businessGroup: this.userInfo.businessGroup })
            .then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.returnPath();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
        });
        // this.$baseRequest
        //   .doWithdrawCommon(API.RECALL_STORAGELADE, params)
        //   .then(() => {
        //     this.returnPath();
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //   });
        /* this.loading.startLoading();
      this.$axios
        .post(API.RECALL_STORAGELADE, obj)
        .then(res => {
          if (0 == res.data.code) {
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success"
            });
            this.returnPath();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error"
            });
          }
        })
        .finally(() => this.loading.endLoading()); */
      },
      // 打印
      print() {
        this.$refs.printDialog.openDialog(true);
      },
      saveactualSendQuantity() {
        let params = {
          ladingNo: this.basicData.ladingNo,
          storageLadingPickingList: this.$refs.productDetails.storageLadingPicking,
          storageLadingPickingDetailList:
            this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList,
        };
        this.$axios.post(API.UPDATE_SALES_SEND, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: this.$t('salesBill.message.makeSuccess'),
              type: 'success',
            });
            this.getLadingDetail(this.basicData.ladingNo);
            //this.returnPath()
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //从销售换货跳转过来
      getChangeDetail(obj) {
        this.basicData = {
          ...obj,
        };
        delete this.basicData.storageLadingPicking;
        this.storageLadingPicking = JSON.parse(JSON.stringify(obj.storageLadingPicking));
        this.basicData.ladingTotalAmountDesc = digitUppercase(
          this.basicData.businessLadingTotalAmount
        );
        this.basicData.ladingTotalQuantityDesc = toUpperCase(this.basicData.ladingTotalQuantity);
        this.basicData.ladingType = '2';
        this.storage = {
          storageNo: this.basicData.storageNo || '',
          storageName: this.basicData.storageName || '',
        };
        this.returnStatusName = obj.returnStatusName;
        this.returnStatus = obj.returnStatus;
        this.returnNo = obj.returnNo;
        this.loadFlag = true;
      },
      //最晚收货日期--操作日期+1个月
      getNextMonth(date) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        console.log(days);
        days = days.getDate(); //获取当前日期中的月的天数
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = '0' + month2;
        }

        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
      },
      //新增时候基本信息赋值
      getBaseDetail(storageLadingPicking) {
        const type = this.$route.query.type;
        this.storageLadingPicking =
          storageLadingPicking.map((item) => {
            // 特殊处理双边的
            if (type == 'bilateralContract') {
              return {
                ...item,
                businessChangingUnitPrice: item?.businessChangingUnitPrice
                  ? item?.businessChangingUnitPrice
                  : item?.businessContractUnitPrice,
              };
            } else {
              return {
                ...item,
              };
            }
          }) || [];
        this.basicData.ladingSalesmanNo =
          this.storageLadingPicking[0].personChargeCode ||
          this.storageLadingPicking[0].contractSalesmanNo; //业务员
        this.basicData.ladingSalesmanName =
          this.storageLadingPicking[0].personChargeName ||
          this.storageLadingPicking[0].contractSalesmanName; // 双边合同用contractSalesmanName
        this.basicData.ladingBusinessDepartmentNo =
          this.storageLadingPicking[0].contractBusinessDepartment; //业务部门
        this.basicData.ladingBusinessDepartmentName =
          this.storageLadingPicking[0].contractBusinessDepartmentName; //业务部门
        this.basicData.contractCurrency = this.storageLadingPicking[0].contractCurrency; //合同带过来
        this.basicData.ladingCurrency = this.storageLadingPicking[0].contractCurrency || 'CNY'; //货币 默认人民币
        this.basicData.ladingCurrencyName = this.storageLadingPicking[0].contractCurrencyName; //货币
        this.basicData.companyCurrency = this.storageLadingPicking[0].companyCurrency;
        this.basicData.companyCurrencyName = this.storageLadingPicking[0].companyCurrencyName;
        this.basicData.exchangeRate =
          this.storageLadingPicking[0].contractCurrencyExchangeRate || 1; // 汇率
        this.basicData.tradeTypeName = this.storageLadingPicking[0].tradeTypeName; // 贸易类型
        this.basicData.tradeType = this.storageLadingPicking[0].tradeType; // 贸易类型
        this.basicData.customerNo = this.storageLadingPicking[0].customerNo; //客户
        this.basicData.customerName = this.storageLadingPicking[0].customerName; //客户
        this.basicData.contractNo = this.storageLadingPicking[0].contractNo; //合同号
        this.basicData.receivingUnit = this.storageLadingPicking[0].customerName;
        this.basicData.contractNo = this.storageLadingPicking[0].contractNo; //合同号
        this.basicData.externalContractNo = this.storageLadingPicking[0].externalContractNo; //外部合同号
        this.basicData.lastestReceiveMoneyDay = this.getNextMonth(dateFormat(new Date()));

        this.basicData.ladingBusinessCompanyCode =
          this.storageLadingPicking[0].contractBusinessCompanyNo;
        this.basicData.ladingBusinessCompanyName =
          this.storageLadingPicking[0].contractBusinessCompanyName;
        this.basicData.companyCurrencyCode = this.storageLadingPicking[0].companyCurrency;

        // this.changeCurrencyList(this.storageLadingPicking[0].companyCurrency)
        let isSameStorage = true; //默认明细商品在同一个仓库
        this.storageLadingPicking.forEach((item) => {
          if (item.storageNo != this.storageLadingPicking[0].storageNo) {
            //如果商品不在同一仓库 仓库默认为空
            isSameStorage = false;
          }
          item.actualSendQuantity = item.ladingQuantity;
        });
        this.basicData.storageNo = isSameStorage
          ? this.storageLadingPicking[0].storageNo
          : this.storageLadingPicking[0].storageNo
          ? this.storageLadingPicking[0].storageNo
          : '';
        this.basicData.storageName = isSameStorage
          ? this.storageLadingPicking[0].storageName
          : this.storageLadingPicking[0].storageName
          ? this.storageLadingPicking[0].storageName
          : '';
        this.basicData.deliveryMethod = this.storageLadingPicking[0].deliverType
          ? this.storageLadingPicking[0].deliverType
          : '';
        this.basicData.shippingMethod = this.storageLadingPicking[0].shippingMethod
          ? this.storageLadingPicking[0].shippingMethod
          : '';
        this.loadFlag = true;
        this.storage = {
          storageNo: this.basicData.storageNo || '',
          storageName: this.basicData.storageName || '',
        };
        const params = {
          fromCurrencyCode: this.basicData.ladingCurrency,
          toCurrencyCode: this.basicData.companyCurrency,
        };
        //增加入参汇率类型exchangeType: Cooperate  公司类型  User 用户类型，除收付款单据其他汇率日期exchangeDate取月初日期
        params.exchangeType = 'Cooperate';
        params.exchangeDate = this.$baseRequest.getBeginOfMonth(new Date());
        this.$axios
          .post(API.GET_CURRENCY_EXCHANGE, params)
          .then((res) => {
            this.basicData.exchangeRate = res.data.data.positiveRate || 1;
            this.$refs.pickingTab.calcQuantityChange();
          })
          .catch(() => {
            this.$refs.pickingTab.calcQuantityChange();
          });
      },
      //交货方式
      deliveryMethodChange(val) {
        this.basicData.deliveryMethod = val;
        const storageLadingPicking = this.$refs.productDetails.storageLadingPicking;
        storageLadingPicking.forEach((item) => {
          if (
            this.basicData.deliveryMethod == 'JHFS04' ||
            this.basicData.deliveryMethod == 'JHFS05' ||
            this.basicData.deliveryMethod == 'JHFS06'
          ) {
            item.nonInvoiceQuantity = item.actualSendQuantity;
          } else {
            item.nonInvoiceQuantity = 0;
          }
        });
        this.refreshData(storageLadingPicking);
      },
      //改变仓库
      changeStorageNo(storageNo, storageName) {
        this.basicData.storageNo = storageNo;
        this.basicData.storageName = storageName;
        //仓库改变拣配结果清空
        if (storageNo != this.storage.storageNo) {
          const productData =
            this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList;
          if (productData.length > 0) {
            this.$confirmAction(
              this.$t('departmentBusinessAdd.changestargeTitle'),
              this.$t('departmentBusinessAdd.result')
            )
              .then(() => {
                // 确认选择这个部门：清空商品行数据
                this.storage = { storageNo: storageNo, storageName: storageName };
                this.$refs.pickingTab.storageLadingPickingDetailList = [];
              })
              .catch(() => {
                // 恢复之前仓库
                this.basicData.storageNo = this.storage.storageNo;
                this.basicData.storageName = this.storage.storageName;
                this.$refs.basicForm.setSaleStorage(this.storage);
              });
          } else {
            this.storage = { storageNo: storageNo, storageName: storageName };
          }
        }
      },
      //改变客户
      changeCustomerNo(customerNo, customerName) {
        this.basicData.customerNo = customerNo;
        this.basicData.customerName = customerName;
      },
      //改变币种
      changeCurrencyList(val) {
        console.log(val, '修改币种');
        let params = {
          fromCurrencyCode: this.basicData.ladingCurrency,
          toCurrencyCode: val,
          storageLadingPickingList: this.$refs.productDetails.exportTableData(),
          storageLadingPickingDetailList:
            this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList,
          businessLadingTotalAmount: this.basicData.businessLadingTotalAmount, //提单总金额
        };
        this.$axios.post(API.GET_BASIC_INFO_CURRENCY, params).then((res) => {
          if (res.data.code == 0) {
            this.storageLadingPicking = res.data.data.storageLadingPickingList;
            this.storageLadingPickingDetail = res.data.data.storageLadingPickingDetailList;
            this.basicData.businessLadingTotalAmount = res.data.data.businessLadingTotalAmount;
            this.basicData.businessLadingTotalAmountOther =
              res.data.data.businessLadingTotalAmountOther;
            if (val != this.basicData.contractCurrency) {
              this.basicData.ladingTotalAmountDesc = '';
            } else {
              this.basicData.ladingTotalAmountDesc = digitUppercase(
                this.basicData.businessLadingTotalAmount
              );
            }
            if (this.basicData.contractCurrency == val) {
              this.basicData.exchangeRate = 1;
            } else {
              params.fromCurrencyCode = this.basicData.ladingCurrency;
              params.toCurrencyCode = val;
              //增加入参汇率类型exchangeType: Cooperate  公司类型  User 用户类型，除收付款单据其他汇率日期exchangeDate取月初日期
              params.exchangeType = 'Cooperate';
              params.exchangeDate = this.$baseRequest.getBeginOfMonth(new Date());
              this.$axios.post(API.GET_CURRENCY_EXCHANGE, params).then((res) => {
                this.basicData.exchangeRate = res.data.data.positiveRate;
              });
            }
            this.basicData.ladingCurrency = val;
            this.$refs.basicForm.returnOldBurCurryCode = val;
          } else {
            this.$alert(this.$t('businessReceiptList.table.pleaseMakeExchangeRate'));
            this.$refs.basicForm.baseInfo.ladingCurrency =
              this.$refs.basicForm.returnOldBurCurryCode;
          }
        });
        // GET_BASIC_INFO_CURRENCY
      },
      // 根据合同号查询
      getContractDetail(contractNo, contractDetailNoList) {
        this.loading.startLoading();
        this.$axios
          .post(API.LIST_PRODUCT_API, { contractNo, contractDetailNoList })
          .then((res) => {
            if (res.data.code == 0) {
              const data = res.data.data || [];
              const baseList = data.map((item, index) => {
                const result = Object.assign({}, item, {
                  ladingDetailNo: index + 1, // item.contractDetailNo,
                  contractDetailId: item.id,
                  ladingUnit: item.unit,
                  ladingUnitName: item.unitName,
                  salesQuantity: item.productQuantity,
                  // businessChangingUnitPrice: item.businessChangeUnitPrice,
                  pricingId: item.pricingId,
                  businessContractUnitPrice: item.businessContractUnitPrice,
                  //如果是定价则自动赋值
                  businessChangingUnitPrice:
                    item.isFixedPrice == 1 ? item.businessContractUnitPrice : null,
                  availableQuantity: item.availableLadingQuantity,
                  ladingQuantity: item.availableLadingQuantity,
                  taxCode: item.taxCode,
                  taxRate: item.taxRate,
                  maxQuantity: item.availableQuantity,
                  productNo: item.contractMatter,
                  productDesc: item.contractMatterName,
                });
                delete result.id;
                return result;
              });
              this.supplierNo = res.data.data[0].supplierNo;
              this.supplierName = res.data.data[0].supplierName;
              this.basicData.projectInitiationNo = res.data.data[0].projectInitiationNo;
              this.basicData.projectInitiationName = res.data.data[0].projectName;
              this.basicData.platformCompanyName = res.data.data[0].platformCompanyName;
              this.basicData.isCreditsale =
                res.data.data[0].isCreditsale == null ? 0 : res.data.data[0].isCreditsale;
              this.basicData.departmentCode = res.data.data[0].contractBusinessDepartment;
              this.getBaseDetail(baseList);
            }
          })
          .finally(() => this.loading.endLoading());
      },
      //根据提单号查询详情赋值
      getLadingDetail(val = this.$route.query.ladingNo) {
        this.loading.startLoading();
        let params = {
          ladingNo: val,
        };
        const name = this.$route.name;
        this.$axios
          .post(API.DETAIL_DATA_API, params)
          .then((res) => {
            console.log(JSON.stringify(res), '12345');
            this.loadFlag = true;
            if (0 == res.data.code) {
              this.version = res.data.data.version;
              this.ladingStatus = res.data.data?.ladingStatus;
              const {
                ladingNo,
                version,
                tenantCode,
                companyCode,
                departmentCode,
                companyName,
                departmentName,
                ladingCreateDate,
                ladingType,
                ladingStatus,
                contractNo,
                ladingCurrency,
                ladingCurrencyName,
                ladingBusinessDepartmentNo,
                exchangeRate,
                tradeTypeName,
                tradeType,
                ladingBusinessDepartmentName,
                ladingSalesmanNo,
                ladingSalesmanName,
                ladingOperatorNo,
                ladingOperatorName,
                customerNo,
                customerName,
                storageNo,
                storageName,
                deliveryDate,
                deliveryMethod,
                shippingMethod,
                receivingUnit,
                ladingTotalQuantity,
                ladingTotalQuantityDesc,
                businessLadingTotalAmount,
                businessLadingTotalAmountOther,
                ladingTotalAmountDesc,
                deliveryAddress,
                mark,
                isCreditsale,
                lastestReceiveMoneyDay,
                nonInvoiceQuantity,
                externalContractNo,
                amountDelivered,
                outstandingAmount,
                ladingBusinessCompanyCode,
                ladingBusinessCompanyName,
                companyCurrencyCode,
                projectInitiationNo,
                projectInitiationName,
                baseName,
                platformCompanyName,
                relationLadingFlag,
                relationLadingNo,
                relationLadingBusinessCompanyCode,
                relationLadingBusinessCompanyName,
                relationLadingSalesContractNo,
                relationLadingCustomerNo,
                relationLadingCustomerName,
                relationLadingReceivingUnit,
              } = res.data.data;
              console.log(ladingTotalQuantityDesc, '????????');
              // 新增时不需要订单号以及用户信息，取当前用户信息
              this.basicData = Object.assign(
                name == 'materialSalesLadingbillEdit'
                  ? {
                      ladingNo,
                      version,
                      tenantCode,
                      companyCode,
                      departmentCode,
                      companyName,
                      departmentName,
                      ladingCreateDate,
                      ladingOperatorNo,
                      ladingOperatorName,
                      ladingStatus,
                      ladingBusinessCompanyCode,
                      ladingBusinessCompanyName,
                      companyCurrencyCode,
                    }
                  : {},
                {
                  ladingType,
                  contractNo,
                  ladingCurrency,
                  ladingCurrencyName,
                  ladingBusinessDepartmentNo,
                  exchangeRate,
                  tradeTypeName,
                  tradeType,
                  ladingBusinessDepartmentName,
                  ladingSalesmanNo,
                  ladingSalesmanName,
                  customerNo,
                  customerName,
                  storageNo,
                  storageName,
                  deliveryDate,
                  deliveryMethod,
                  shippingMethod,
                  receivingUnit,
                  ladingTotalQuantity,
                  ladingTotalQuantityDesc,
                  businessLadingTotalAmount,
                  businessLadingTotalAmountOther,
                  ladingTotalAmountDesc,
                  deliveryAddress,
                  mark,
                  isCreditsale,
                  lastestReceiveMoneyDay,
                  nonInvoiceQuantity,
                  externalContractNo,
                  amountDelivered,
                  outstandingAmount,
                  ladingBusinessCompanyCode,
                  ladingBusinessCompanyName,
                  companyCurrencyCode,
                  projectInitiationNo,
                  projectInitiationName,
                  baseName,
                  platformCompanyName,
                  relationLadingFlag,
                  relationLadingNo,
                  relationLadingBusinessCompanyCode,
                  relationLadingBusinessCompanyName,
                  relationLadingSalesContractNo,
                  relationLadingCustomerNo,
                  relationLadingCustomerName,
                  relationLadingReceivingUnit,
                }
              );
              console.log(this.basicData, '11111111222');
              this.storage = {
                storageNo: this.basicData.storageNo || '',
                storageName: this.basicData.storageName || '',
              };
              this.basicData.version = res.data.data.version;
              //复制的不需要提单号
              if (this.$route.query.copy == 'copy') {
                this.basicData.ladingNo = '';
              }
              this.basicData.accountingStatus = res.data.data.accountingStatus;
              this.storageLadingPicking = JSON.parse(
                JSON.stringify(res.data.data.storageLadingPickingList)
              );
              this.storageLadingPickingDetail = JSON.parse(
                JSON.stringify(res.data.data.storageLadingPickingDetailList)
              );
              //已开票数量大于0，实发数量和实收数量不可修改
              this.storageLadingPicking.forEach((item) => {
                if (this.$route.query.copy == 'copy') {
                  item.invoiceQuantity = 0;
                }
                this.storageLadingPickingDetail.forEach((obj) => {
                  if (
                    Number(item.invoiceQuantity) > 0 &&
                    item.ladingDetailNo == obj.ladingDetailNo
                  ) {
                    obj.disabled = true;
                  }
                });
              });
              this.storageAttachmentList = JSON.parse(
                JSON.stringify(res.data.data.storageAttachmentList)
              );
              this.storageLadingShippingDetailList = JSON.parse(
                JSON.stringify(res.data.data.storageLadingShippingDetailList)
              );
              this.id = res.data.data.id || '';
              this.show = true;
              //实发总数量
              this.basicData.actualSendQuantityTotal = this.storageLadingPicking
                .map((it) => it.actualSendQuantity)
                .reduce((prev, curr) => {
                  return this.$cal.calCommon(prev, curr, '+', 'quantity');
                }, 0);
              this.basicData.actualSendQuantityTotalDesc = toUpperCase(
                this.basicData.actualSendQuantityTotal
              );
              //实发总金额
              this.storageLadingPicking.forEach((item) => {
                if (!item.actualSendQuantity) {
                  this.basicData.actualSendAmountTotal = 0;
                } else {
                  this.basicData.actualSendAmountTotal = this.$cal.calCommon(
                    this.$cal.calCommon(
                      item.actualSendQuantity,
                      item.businessChangingUnitPrice,
                      '*',
                      'amount'
                    ),
                    this.basicData.actualSendAmountTotal || 0,
                    '+',
                    'amount'
                  );
                }
              });
              this.basicData.actualSendAmountTotalDesc = digitUppercase(
                this.basicData.actualSendAmountTotal
              );
              // 根据状态确定是否可编辑：已保存、审批驳回、已撤回
              const editStatus = ['TDZT01', 'TDZT04', 'TDZT10'];
              const editStatus1 = ['TDZT07'];
              if (editStatus.includes(ladingStatus)) {
                this.disabled = false;
              }
              if (editStatus1.includes(ladingStatus)) {
                this.disabled = true;
                this.editConfigFlag = true;
                // this.show = false;
              }
              if (this.$route.name == 'materialSalesLadingbillAdd') {
                this.disabled = false;
                //复制过来的新增 更新可提数量和变动单价
                this.updateQuantityAndChangePrice();
              } else {
                //详情或者修改 变动变动价格
                this.updateChangePrice();
              }
              // 获取凭证ID 获取凭证列表
              this.entityDataId = res.data.data.id;
              this.checkSettleParams.associationNoList = [this.$route.query.ladingNo];
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => {
            this.loading.endLoading();
            this.getHistoryList();
          });
      },
      //查询详情变动价格更新
      updateChangePrice() {
        let contractDetailNos = [];
        this.storageLadingPicking.map((item) => {
          contractDetailNos.push(item.ladingDetailNo);
        });
        this.loading.startLoading();
        this.$axios
          .post(API.LIST_PRODUCT_API, {
            contractNo: this.basicData.contractNo,
            contractDetailNos: contractDetailNos,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.storageLadingPicking.map((item, index) => {
                // item.businessChangingUnitPrice =
                //   res.data.data[index].businessChangeUnitPrice;
                this.basicData.contractCurrency = res.data.data[index].contractCurrency;
              });
              this.loadFlag = true;
            }
          })
          .finally(() => this.loading.endLoading());
      },
      updateQuantityAndChangePrice() {
        let errorFlag = false; //默认数量满足 复制来的提单数量 大于更新后的可提数量
        let contractDetailNos = [];
        this.storageLadingPicking.map((item) => {
          contractDetailNos.push(item.ladingDetailNo);
        });
        this.loading.startLoading();
        this.$axios
          .post(API.LIST_PRODUCT_API, {
            contractNo: this.basicData.contractNo,
            contractDetailNos: contractDetailNos,
          })
          .then((res) => {
            if (res.data.code == 0) {
              const pickList = JSON.parse(JSON.stringify(this.storageLadingPicking));
              let data = res.data.data || [];
              for (let i = 0; i < pickList.length; i++) {
                // pickList[i].businessChangingUnitPrice = data[i].businessChangeUnitPrice;
                pickList[i].availableQuantity = data[i].availableLadingQuantity;
                if (pickList[i].availableQuantity < pickList[i].ladingQuantity) {
                  errorFlag = true;
                  //  pickList[i].ladingQuantity = 0;
                }
              }
              this.storageLadingPicking = JSON.parse(JSON.stringify(pickList));
              this.storageLadingPicking.map((item) => {
                item.customerReceiveQuantity = 0;
                //item.actualSendQuantity = 0;//复制提单时解决实发需与提单数量一致问题
                item.nonInvoiceQuantity = 0;
              });
              this.basicData.contractCurrency =
                this.storageLadingPicking.length > 0
                  ? this.storageLadingPicking[0].contractCurrency
                  : this.basicData.contractCurrency;
            }
            this.loadFlag = true;
            if (errorFlag) {
              this.$message({
                showClose: true,
                message: this.$t('salesBill.message.quantityInsufficient'),
                type: 'error',
              });
            }
            this.storageLadingPickingDetail = [];
          })
          .finally(() => this.loading.endLoading());
      },
      // 上传附件成功
      handleUpload(uploadTableData) {
        this.storageAttachmentList = uploadTableData;
        let params = {
          ladingNo: this.$route.query.ladingNo,
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
          storageAttachmentList: this.storageAttachmentList,
        };
        this.$axios.post(API.SAVE_STORAGE_LADE_ATTACHMENT, params).then((res) => {
          if (res.data.code == 0) {
            return;
          }
        });
      },
      //加法计算精度问题
      accAdd(arg1, arg2) {
        var r1, r2, m, c;
        try {
          r1 = arg1.toString().split('.')[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split('.')[1].length;
        } catch (e) {
          r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
          var cm = Math.pow(10, c);
          if (r1 > r2) {
            arg1 = Number(arg1.toString().replace('.', ''));
            arg2 = Number(arg2.toString().replace('.', '')) * cm;
          } else {
            arg1 = Number(arg1.toString().replace('.', '')) * cm;
            arg2 = Number(arg2.toString().replace('.', ''));
          }
        } else {
          arg1 = Number(arg1.toString().replace('.', ''));
          arg2 = Number(arg2.toString().replace('.', ''));
        }
        return (arg1 + arg2) / m;
      },
      //保存
      saveData() {
        this.sureSave('TDZT01');
      },
      //提交
      submit() {
        /* if (!this.basicData.ladingNo) {
        return this.sureSave("TDZT01");
      }  */
        const that = this;
        Promise.all([
          this.$refs.basicForm.validateAll(),
          this.$refs.productDetails.validateAll(),
          this.$refs.pickingTab.validateAll(),
        ])
          .then(() => {
            let ladingbillLength = 0; //提单数量
            let matchingLength = 0; //拣配数量
            let allLadingFlag = true; //是否全部提单 且都不为0
            let storageLadingPickingList =
              this.$refs.pickingTab.exportTableData().storageLadingPickingList || []; //商品明细
            let storageLadingPickingDetailList =
              this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList || []; //拣配结果

            storageLadingPickingList.forEach((item) => {
              ladingbillLength = this.$cal.calCommon(ladingbillLength, item.ladingQuantity, '+', 8);
              if (item.ladingQuantity == 0) {
                allLadingFlag = false;
              }
            });
            // storageLadingPickingList.map(item => {
            //   ladingbillLength = this.$cal.calCommon(ladingbillLength,item.ladingQuantity,"+","quantity");
            //   if (item.ladingQuantity == 0) {
            //     allLadingFlag = false;
            //   }
            // });
            const matchNum = [];
            storageLadingPickingDetailList.map((item) => {
              return matchNum.push(item.pickingQuantity || 0);
            });
            matchingLength =
              matchNum.length == 0
                ? 0
                : matchNum.reduce((prev, curr) => {
                    return this.$cal.calCommon(prev, curr, '+', 8);
                  }, 0);
            Promise.resolve().then(() => {
              // matchingLength=res

              if (storageLadingPickingList.length == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('salesBill.message.notSelectedBillLading'),
                  type: 'error',
                });
                return;
              }
              if (ladingbillLength == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('salesBill.message.quantityCannotZero'),
                  type: 'error',
                });
                return;
              }
              console.log(ladingbillLength, matchingLength, allLadingFlag, '保存---');
              if (ladingbillLength != matchingLength || !allLadingFlag) {
                this.$message({
                  showClose: true,
                  message: this.$t('salesBill.message.goodNotSortingMatching'),
                  type: 'error',
                });
                return;
              }
              let numberList = [];
              storageLadingPickingList.forEach((item) => {
                if (item.unit == 'KG' || item.unit == 'T') {
                  let unitObject = {
                    productQuantity: item.productQuantity,
                    productUnit: item.unit,
                  };
                  numberList.push(unitObject);
                }
              });
              if (numberList.length > 0) {
                let query = {
                  adds: numberList,
                  businessDepartmentNo: this.basicData.ladingBusinessDepartmentNo, //事业部门
                  partnerType: 'HZHB01',
                  partnerNo: this.basicData.customerNo, //合作伙伴待定
                  businessDepartmentName: this.basicData.ladingBusinessDepartmentName,
                };
                that.$axios.post(API.BEFORE_SAVE_ORDER_API, query).then((res) => {
                  if (0 == res.data.code) {
                    this.sureSave('TDZT02');
                  } else {
                    this.$repeatConfirm(
                      "<div><img src='/static/img/tips.png'/>" +
                        "<div class='repeatContent'>" +
                        res.data.msg +
                        '</div></div>',
                      '',
                      {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: this.$t('salePurchase.message.submitAgain'),
                        cancelButtonText: this.$t('confirm.cancel'),
                        center: true,
                        callback: (action) => {
                          if (action === 'confirm') {
                            this.sureSave('TDZT02');
                          } else {
                            this.$message({
                              type: 'info',
                              message: this.$t('salePurchase.message.gitUpSubmitAgain'),
                            });
                          }
                        },
                      }
                    );
                  }
                });
              } else {
                this.sureSave('TDZT02');
              }
            });
          })
          .catch(() => {});
      },
      //确认提交
      sureSave(val) {
        let saveAPI = '';
        let { tenantCode } = this.userInfo.tenantCode;
        // let otherData = { ladingType: '1', ladingStatus: val };
        //const { ladingNo, version, tenantCode, companyCode, departmentCode, companyName, departmentName, ladingCreateDate,contractNo,ladingCurrency,ladingBusinessDepartmentNo, }
        let basicData = this.$refs.basicForm.baseInfo; //上面表单的值
        if (basicData.ladingNo) {
          //存在则是修改
          saveAPI = API.UPDATE_DATA_API;
        } else {
          saveAPI = API.SAVE_DATA_API;
        }
        if (val == 'TDZT01') {
          saveAPI = API.SAVE_DATA_API;
        } else if (val == 'TDZT02') {
          //新建单据直接提交
          saveAPI = API.UPDATE_DATA_API;
        }
        let storageLadingPickingList =
          this.$refs.pickingTab.exportTableData().storageLadingPickingList || []; //商品明细
        //未开票总数量等于行项目未开票数量
        basicData.nonInvoiceQuantity = 0;
        storageLadingPickingList.map((item) => {
          return (basicData.nonInvoiceQuantity = this.$cal.calCommon(
            basicData.nonInvoiceQuantity,
            item.nonInvoiceQuantity,
            '+',
            'quantity'
          ));
        });
        let storageLadingPickingDetailList =
          this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList || []; //拣配结果

        if (!this.checkEqual(storageLadingPickingList, storageLadingPickingDetailList)) {
          return this.$message.error('拣配金额与提单金额不相等');
        }
        // 判断拣配金额是否有0
        let isZero = false;
        storageLadingPickingDetailList.forEach((item) => {
          if (item.businessPickingAmount == 0) {
            isZero = true;
          }
        });
        if (isZero) {
          return this.$message.error('拣配金额不能为0');
        }

        let storageAttachmentList = this.storageAttachmentList;
        let obj = {};
        if (saveAPI == API.UPDATE_DATA_API && this.id) {
          obj.id = this.id;
          if (this.$route.query.copy == 'copy') {
            obj.id = null;
          }
        }
        if (saveAPI == API.SAVE_DATA_API && basicData.ladingNo) {
          obj.id = this.id;
        }
        console.log('obj---1', obj.ladingStatus, this.basicData.ladingNo);
        let ladingStatus = '';
        if (val == 'TDZT01') {
          ladingStatus = 'TDZT01';
        } else {
          if (this.basicData.ladingNo && this.ladingStatus) {
            ladingStatus = this.ladingStatus;
          } else {
            ladingStatus = 'TDZT01';
          }
        }
        obj = Object.assign(
          obj,
          basicData,
          tenantCode,
          {
            storageLadingPickingList:
              storageLadingPickingList.length == 0 ? [] : storageLadingPickingList,
          },
          {
            storageLadingPickingDetailList:
              storageLadingPickingDetailList.length == 0 ? [] : storageLadingPickingDetailList,
          },
          {
            storageAttachmentList: storageAttachmentList.length == 0 ? [] : storageAttachmentList,
          },
          { ladingStatus: ladingStatus }
        );
        console.log('obj---2', obj.ladingStatus, this.basicData.ladingNo);
        // return;
        obj.version = this.version;
        obj.supplierName = this.supplierName;
        obj.supplierNo = this.supplierNo;
        obj.ladingStatusVal = val;
        obj.businessGroup = this.userInfo.businessGroup;
        // obj.storageLadingPickingDetailList.forEach(item=>{
        //   item.unit=item.ladingUnit
        // })
        if (saveAPI == API.UPDATE_DATA_API && this.id && this.basicData.relationLadingNo) {
          this.$confirmAction(
            this.$t('salePurchase.message.submitRelationTitle'),
            this.$t('salePurchase.message.submitRelationContent') + this.basicData.relationLadingNo
          )
            .then(() => {
              this.loading.startLoading();
              this.saveImport(saveAPI, obj);
            })
            .catch(() => {});
        } else {
          this.loading.startLoading();
          this.saveImport(saveAPI, obj);
        }
      },
      // 校验拣配行的提单金额合计是否与拣配结果的拣配金额合计是否相等
      checkEqual(storageLadingPickingList, storageLadingPickingDetailList) {
        const storageLadingPickingListAmount = storageLadingPickingList
          .map((it) => it.businessLadingAmount)
          .reduce((prev, curr) => {
            return this.$cal.calCommon(prev, curr, '+').toFixed(2);
          }, 0);
        const storageLadingPickingDetailListAmount = storageLadingPickingDetailList
          .map((it) => it.businessPickingAmount)
          .reduce((prev, curr) => {
            return this.$cal.calCommon(prev, curr, '+').toFixed(2);
          }, 0);
        if (storageLadingPickingListAmount == storageLadingPickingDetailListAmount) {
          return true;
        } else {
          return false;
        }
      },
      saveImport(saveAPI, obj) {
        this.$axios
          .post(saveAPI, { ...obj, businessGroup: this.userInfo.businessGroup })
          .then((res) => {
            if (10 == res.data.code) {
              this.loading.endLoading();
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  obj.cancelValidate = true;
                  this.saveImport(saveAPI, obj);
                },
              });
            } else if (0 == res.data.code) {
              this.loading.endLoading();
              this.$message({
                showClose: true,
                // message: this.$t("salesBill.message.makeSuccess"),
                message: res.data.msg,
                type: 'success',
              });
              if (this.returnStatusName) {
                //销售退换货过来的标记
                let returnParams = {};
                returnParams.returnNo = this.returnNo;
                // returnParams.returnStatus = val == 'TDZT01' ? 'ZT03' : 'ZT07';
                returnParams.exchangeLadingNo = res.data.data || '';
                // this.$axios.post(API.UPDATE_SALES_RETURN, returnParams).then((res) => {
                //   if (0 == res.data.code) {
                //     if (val == 'TDZT01') {
                //       if (this.$route.name == 'salesLadingbillAdd') {
                //         this.dblclickEvent(res.data.data);
                //       } else {
                //         this.getLadingDetail(this.$route.query.ladingNo);
                //       }
                //     } else {
                //       this.returnPath();
                //     }
                //   }
                // });
              } else {
                if (obj.ladingStatusVal == 'TDZT01') {
                  if (this.$route.name == 'materialSalesLadingbillAdd') {
                    this.dblclickEvent(res.data.data);
                  } else {
                    this.getLadingDetail(this.$route.query.ladingNo);
                  }
                } else {
                  this.returnPath();
                }
              }
            } else if (8 == res.data.code) {
              this.loading.endLoading();
              this.$message({
                showClose: true,
                // message: this.$t("salesBill.message.makeSuccess"),
                message: res.data.msg,
                type: 'error',
              });
              if (this.returnStatusName) {
                //销售退换货过来的标记
                let returnParams = {};
                returnParams.returnNo = this.returnNo;
                // returnParams.returnStatus = val == 'TDZT01' ? 'ZT03' : 'ZT07';
                returnParams.exchangeLadingNo = res.data.data || '';
                // TODO val未知
                // this.$axios.post(API.UPDATE_SALES_RETURN, returnParams).then((res) => {
                //   if (0 == res.data.code) {
                //     if (val == 'TDZT01') {
                //       if (this.$route.name == 'salesLadingbillAdd') {
                //         this.dblclickEvent(res.data.data);
                //       } else {
                //         this.getLadingDetail(this.$route.query.ladingNo);
                //       }
                //     } else {
                //       this.returnPath();
                //     }
                //   }
                // });
              }
              // TODO val未知
              // else {
              //   if (val == 'TDZT01') {
              //     if (this.$route.name == 'salesLadingbillAdd') {
              //       this.dblclickEvent(res.data.data);
              //     } else {
              //       this.getLadingDetail(this.$route.query.ladingNo);
              //     }
              //   } else {
              //     this.returnPath();
              //   }
              // }
            } else {
              this.loading.endLoading();
              // this.$alert(res.data.msg);
              this.$repeatAlert(
                "<div><img src='./static/img/error.png'/><div class='confirmTitle'>" +
                  this.$t('alert.error') +
                  '</div>' +
                  "<div class='confirmContent'>" +
                  res.data.msg +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('alert.confirm'),
                  center: true,
                  callback: () => {
                    if (res.data.data) {
                      this.dblclickEvent(res.data.data);
                    }
                    //  this.returnPath();
                  },
                }
              );
            }
          })
          .catch(() => this.loading.endLoading());
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/salePurchase/materialSalesLadingbillAdd',
            name: 'materialSalesLadingbillAdd',
            meta: {
              keepAlive: true,
              title: this.$t('salesBill.message.addSale'),
            },
          },
          toPath: {
            path: '/salePurchase/materialSalesLadingbillEdit',
            name: 'materialSalesLadingbillEdit',
            meta: {
              keepAlive: false,
              title: this.$t('salesBill.message.editSale'),
            },
            query: {
              ladingNo: value || this.$route.query.ladingNo,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      returnPath() {
        const name = this.$route.name;
        let path = {
          fromPath: {
            path: '/salePurchase/' + name,
            name: name,
            meta: {
              keepAlive: true,
              title:
                name == 'materialSalesLadingbillAdd'
                  ? this.$t('salesBill.message.addSale')
                  : this.$t('salesBill.message.editSale'),
            },
          },
          toPath: {
            path: '/salePurchase/salesLadingbill',
            name: 'salesLadingbill',
            meta: {
              keepAlive: false,
              title: this.$t('salesBill.message.searchSale'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //生成运输单
      creatTransportBill() {
        let shop = [];
        let shipping = [];
        let obj = Object.assign({}, this.basicData);
        // const notStatus = ["TDZT04", "TDZT05", "TDZT01"];
        // if (notStatus.includes(obj.ladingStatus)) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t("salesBill.message.unableToGenerate"),
        //     type: "error"
        //   });
        //   return;
        // }
        this.loading.startLoading();
        this.$axios
          .post(API.DETAIL_DATA_API, { ladingNo: obj.ladingNo })
          .then((res) => {
            if (res.data.code == 0) {
              shop = res.data.data.storageLadingPickingList;
              shipping = res.data.data.storageLadingShippingDetailList;
            }
          })
          .finally(() => {
            creatTransportBill(obj, shop, this.userInfo, shipping)
              .then((res) => {
                if (res.data.code == 0) {
                  // TODO 生成成功后是否需要跳转到运输单页面去
                  this.$message({
                    showClose: true,
                    message: this.$t('salesBill.message.generateSuccess'),
                    type: 'success',
                  });
                  this.returnPath();
                } else {
                  this.$alert(res.data.msg);
                }
              })
              .finally(() => this.loading.endLoading());
          });
      },
      //生成运输单查询校验
      surecreatTransportBill() {
        const notStatus = ['TDZT04', 'TDZT05'];
        if (notStatus.includes(this.basicData.ladingStatus)) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.unableToGenerate'),
            type: 'error',
          });
          return;
        }
        let params = {
          salesLadingNo: this.$route.query.ladingNo,
          contractNo: this.basicData.contractNo,
        };
        this.$axios.post(API.CALC_PICK_DELIVERY, params).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data == 0) {
              this.creatTransportBill();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('salesBill.message.transTip'),
                type: 'error',
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删除
      deteleBill() {
        this.$confirmAction().then(() => {
          let obj = {};
          let ladingNoList = [];
          let contractNoList = [];
          ladingNoList.push(this.basicData.ladingNo);
          contractNoList.push(this.basicData.contractNo);
          obj.ladingNoList = ladingNoList;
          obj.contractNoList = contractNoList;
          this.$axios
            .post(API.DELETE_DATA_API, ladingNoList)
            .then((res) => {
              if (res.data.code == 0) {
                // TODO 生成成功后是否需要跳转到运输单页面去
                this.$message({
                  showClose: true,
                  message: this.$t('salesBill.message.delSuccess'),
                  type: 'success',
                });
                this.returnPath();
              } else {
                this.$alert(res.data.msg);
              }
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('salesBill.message.cancelledDelete'),
              });
            });
        });
      },
      //商品明细表格发生变化
      goodsTableChange(arr) {
        this.storageLadingPicking = arr;
        // let contractDetailNoList = arr.map((item) => {
        //   return item.contractDetailNo;
        // });
        //提单号和合同号
        let ladingDetailNoList = arr.map((item) => {
          return item.ladingDetailNo;
        });
        let list = [];
        this.$refs.pickingTab.storageLadingPickingDetailList.forEach((rs) => {
          ladingDetailNoList.forEach((item) => {
            if (rs.ladingDetailNo == item) {
              list.push(rs);
            }
          });
        });
        //删除后提单号根据行项目号改变,拣配结果提单号也要改变
        this.storageLadingPicking.forEach((item, index) => {
          var flagNo = item.ladingDetailNo;
          item.ladingDetailNo = index + 1;
          list.forEach((itemList) => {
            if (itemList.ladingDetailNo == flagNo) {
              itemList.ladingDetailNo = item.ladingDetailNo;
            }
          });
        });
        this.$refs.pickingTab.storageLadingPickingDetailList = list;
        //更新提单数量
        let ladingTotalQuantity = new Big(0);
        let businessLadingTotalAmount = new Big(0);
        let businessLadingTotalAmountOther = new Big(0);
        this.storageLadingPicking.forEach((item) => {
          ladingTotalQuantity = ladingTotalQuantity.plus(item.ladingQuantity);
          businessLadingTotalAmount = businessLadingTotalAmount.plus(item.businessLadingAmount);
          businessLadingTotalAmountOther = businessLadingTotalAmountOther.plus(
            item.businessLadingAmountOther
          );
        });
        ladingTotalQuantity = ladingTotalQuantity.toFixed(8); // 提单总数量
        businessLadingTotalAmount = businessLadingTotalAmount.toFixed(6);
        businessLadingTotalAmountOther = businessLadingTotalAmountOther.toFixed(6);
        console.log('进来了', ladingTotalQuantity);
        //更新提单总额
        this.basicData.ladingTotalQuantity = ladingTotalQuantity;
        this.basicData.ladingTotalQuantityDesc = toUpperCase(ladingTotalQuantity);
        this.basicData.businessLadingTotalAmount = businessLadingTotalAmount;
        this.basicData.businessLadingTotalAmountOther = businessLadingTotalAmountOther;
        if (this.basicData.ladingCurrency == 'CNY') {
          this.basicData.ladingTotalAmountDesc = digitUppercase(businessLadingTotalAmount);
        } else {
          this.basicData.ladingTotalAmountDesc = '';
        }
        //更新拣配明细
      },
      //提单数量发生变化 计算总运费，计算提单总金额、数量
      calcLadingPicking(data, obj) {
        console.log(data, obj, '????111', data.businessLadingTotalAmount);
        const amount = {
          businessLadingTotalAmount: this.$cal.calCommon(
            0,
            data.businessLadingTotalAmount,
            '+',
            'amount'
          ),
          businessLadingTotalAmountOther: this.$cal.calCommon(
            0,
            data.businessLadingTotalAmountOther,
            '+',
            'amount'
          ),
          ladingTotalAmountDesc: digitUppercase(
            this.$cal.calCommon(0, data.businessLadingTotalAmount, '+', 'amount')
          ),
          ladingTotalQuantity: new Big(0).plus(data.ladingTotalQuantity).toFixed(8),
          ladingTotalQuantityDesc: toUpperCase(
            this.$cal.calCommon(0, data.ladingTotalQuantity, '+', 'quantity')
          ),
        };
        if (this.basicData.ladingCurrency != 'CNY') {
          amount.ladingTotalAmountDesc = '';
        }
        this.$refs.basicForm.setTotal(amount);
        this.basicData = Object.assign({}, this.basicData, amount);
        console.log(this.basicData.businessLadingTotalAmount, '??--');
        this.refreshData(obj);
      },
      //tab1表格提单数量影响表格二
      ladingQuantityChange(val, row, scope, obj) {
        this.refreshData(obj);
        this.$refs.pickingTab.ladingQuantityChange(val, row, scope);
      },
      changePrice(val, row, scope, obj) {
        this.refreshData(obj);
        this.$refs.pickingTab.calcQuantityChange(val, row, scope);
      },
      refreshData(obj) {
        //未开票总数量
        const totalAddNum = [];
        obj.forEach((item) => {
          totalAddNum.push(item.nonInvoiceQuantity || 0);
        });
        Promise.resolve(this.calculateAdd(totalAddNum)).then((res) => {
          this.basicData.nonInvoiceQuantity = res;
        });
        this.storageLadingPicking = JSON.parse(JSON.stringify(obj));
        this.$refs.productDetails.refreshPage(this.storageLadingPicking);
        this.$refs.pickingTab.refreshPage(this.storageLadingPicking);
      },
      //修改价格
      editChangePrice() {
        this.$refs.changePrice.getPriceDetail();
      },
      Rejected() {
        this.freezeThaw();
      },
      //次数打印
      getUpDataNo(row) {
        let params = {
          attachmentId: row.attachmentId,
        };
        this.$axios.post(API.ADD_PRINT_NUMBER, params).then((res) => {
          if (res.data.code == 0) {
            this.getHistoryList();
          }
        });
      },
      getHistoryList() {
        let params = {
          dataType: 'STORAGE_LADING',
          dataNo: this.basicData.ladingNo,
          attachmentCategory: '1',
        };
        this.$axios.post(API.HISTORY_LIST_ATTACHMENT_PAGE, params).then((res) => {
          if (res.data.code == 0) {
            this.attachmentCategoryDataList = res.data.data;
          }
        });
      },
      //已冻结下财务驳回
      freezeThaw() {
        if (this.basicData.ladingStatus != 'TDZT05') {
          this.$message({
            showClose: true,
            message: '只有已冻结状态下财务可进行驳回',
            type: 'error',
          });
          return;
        }
        let api = API.DISABLE_RETURN;
        const params = {
          ladingNo: this.basicData.ladingNo,
        };
        this.loading.startLoading();
        this.$axios
          .post(api, params)
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.getLadingDetail(this.$route.query.ladingNo);
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .finally(() => this.loading.endLoading());
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
    },
    watch: {
      basicData: {
        handler: function (newValue, oldValue) {
          console.log(newValue, oldValue, '监听变化');
          this.$forceUpdate();
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>
